import styled from 'styled-components';

const DropdownWrapper = styled.div`
    position: absolute;
    top: ${props => props.top ? props.top : "50px"};
    ${props => props.right ? `right: ${props.right};` : `left: ${props.left ? props.left : "10px"};`}
    // min-width: 160px;
    min-height: 20px;
    background: #FFFFFF;
    border-radius: 8px;
    overflow: hidden;
    border: 1px solid #E2E4E8;
    z-index: 1;
    height:160px;
    overflow-y:auto;
`

export default DropdownWrapper;